"use client";

import { m as motion, useMotionValueEvent, useScroll } from "framer-motion";
import { useState } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";

import { Link } from "@/i18n/navigation";
import { LocaleSwitcher } from "./LocaleSwitcher";
import { NavDropdown } from "./NavDropdown";
import { MobileMenu } from "./MobileMenu";

export function SiteNav() {
  const t = useTranslations("nav");
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);

  useMotionValueEvent(scrollY, "change", (y) => {
    setScrolled(y > 24);
  });

  return (
    <motion.nav
      data-scrolled={scrolled || undefined}
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-between px-5 py-[18px] md:px-10"
      initial={false}
      animate={{
        backgroundColor: scrolled ? "rgba(10,10,15,0.72)" : "rgba(10,10,15,0)",
        backdropFilter: scrolled ? "blur(14px) saturate(140%)" : "blur(0px)",
        borderBottomColor: scrolled
          ? "rgba(245,245,247,0.08)"
          : "rgba(245,245,247,0)",
      }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      style={{
        WebkitBackdropFilter: scrolled
          ? "blur(14px) saturate(140%)"
          : undefined,
        borderBottom: "1px solid transparent",
      }}
    >
      <Link href="/" className="flex items-center" aria-label="Mai Dijital">
        <Image
          src="/icons/icon-512.png"
          alt="Mai Dijital"
          width={36}
          height={36}
          priority
          className="h-9 w-9 object-contain"
        />
      </Link>

      <div className="hidden items-center gap-2 md:flex">
        <NavDropdown />
        <Link
          href="/catalog"
          className="rounded-full px-[14px] py-2 text-sm text-fg2 transition-colors hover:bg-white/[0.04] hover:text-fg1"
        >
          {t("catalog")}
        </Link>
        <Link
          href="/products"
          className="rounded-full px-[14px] py-2 text-sm text-fg2 transition-colors hover:bg-white/[0.04] hover:text-fg1"
        >
          {t("products")}
        </Link>
        <Link
          href="/studio"
          className="rounded-full px-[14px] py-2 text-sm text-fg2 transition-colors hover:bg-white/[0.04] hover:text-fg1"
        >
          {t("studio")}
        </Link>
        <Link
          href="/contact"
          className="rounded-full px-[14px] py-2 text-sm text-fg2 transition-colors hover:bg-white/[0.04] hover:text-fg1"
        >
          {t("contact")}
        </Link>
        <LocaleSwitcher ariaLabel={t("lang_aria")} />
      </div>

      <div className="flex items-center gap-1 md:hidden">
        <LocaleSwitcher ariaLabel={t("lang_aria")} />
        <MobileMenu />
      </div>
    </motion.nav>
  );
}
